// removed by extract-text-webpack-plugin
module.exports = {"postlistcontainer":"src-components-PostListing----PostListing-module---postlistcontainer---2Lgyv","articleexcerpt":"src-components-PostListing----PostListing-module---articleexcerpt---284tc"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PostListing/PostListing.module.scss
// module id = 80
// module chunks = 129745722219136 183400410456155 186063380969677